import { useLocation } from 'react-router-dom';
import { LayoutDashboard, Wallet, TrendingUp, Percent, Menu } from 'lucide-react';
import { useLocalizedNavigate } from '@/hooks/useLocalizedNavigate';
import { useLanguage } from '@/context/LanguageContext';
import { LANGUAGE_REGEX_GROUP } from '@/types/language';

interface MobileBottomTabBarProps {
  onMorePress: () => void;
}

const tabs = [
  { key: 'home', icon: LayoutDashboard, path: '/dashboard', labelKey: 'backoffice.mobile.tabs.home' },
  { key: 'accounts', icon: Wallet, path: '/investment-accounts', labelKey: 'backoffice.mobile.tabs.accounts' },
  { key: 'profits', icon: TrendingUp, path: '/my-profits/accounts-summary', labelKey: 'backoffice.mobile.tabs.profits' },
  { key: 'commissions', icon: Percent, path: '/my-profits/commissions-summary', labelKey: 'backoffice.mobile.tabs.commissions' },
];

const MobileBottomTabBar = ({ onMorePress }: MobileBottomTabBarProps) => {
  const navigate = useLocalizedNavigate();
  const location = useLocation();
  const { t } = useLanguage();

  const isActive = (path: string) => {
    const stripped = location.pathname.replace(new RegExp(`^/(${LANGUAGE_REGEX_GROUP})`), '');
    if (path === '/dashboard') return stripped === '/dashboard' || stripped === '';
    return stripped.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-border shadow-lg safe-area-bottom">
      <div className="flex items-center justify-around h-16">
        {tabs.map(({ key, icon: Icon, path, labelKey }) => {
          const active = isActive(path);
          return (
            <button
              key={key}
              onClick={() => navigate(path)}
              className={`flex flex-col items-center justify-center flex-1 h-full gap-0.5 transition-colors ${
                active
                  ? 'text-primary'
                  : 'text-muted-foreground'
              }`}
            >
              <Icon className="h-6 w-6" />
              <span className="text-[11px] font-medium leading-tight">{t(labelKey)}</span>
            </button>
          );
        })}
        <button
          onClick={onMorePress}
          className="flex flex-col items-center justify-center flex-1 h-full gap-0.5 text-muted-foreground transition-colors"
        >
          <Menu className="h-6 w-6" />
          <span className="text-[11px] font-medium leading-tight">{t('backoffice.mobile.tabs.more')}</span>
        </button>
      </div>
    </nav>
  );
};

export default MobileBottomTabBar;
